import React, { PropsWithChildren, useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { store } from '@redux/store'
import { CustomStyles } from '@components/ui/Theme/types'
import { ThemeProvider } from '@components/ui/Theme/ThemeProvider'
import { getEnvironmentOverride } from '@utils/getEnvironmentOverride'
import { getThemeOverride } from '@utils/getThemeOverride'
import i18n from '../i18n'

type WidgetAppProp = {
  appId: string
  brand: string
  locale?: string
  customStyles?: CustomStyles
} & PropsWithChildren

export const WidgetApp: React.FC<WidgetAppProp> = props => {
  const { appId, brand, locale, customStyles, children } = props
  const brandStyles = getThemeOverride() ?? customStyles

  useEffect(() => {
    if (locale) {
      const lang = getEnvironmentOverride()?.lang ?? locale?.split('-')[0] ?? 'en'
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }

      // use country specific namespace as first fallback
      const country = locale?.split('-')[1]
      if (country) {
        i18n.options.fallbackNS = [`translation_${country}`, 'translation']
      }
    }
  }, [locale])

  return (
    <Provider store={store}>
      <ThemeProvider appId={appId} brand={brand} customStyles={brandStyles}>
        <BrowserRouter>{children}</BrowserRouter>
      </ThemeProvider>
    </Provider>
  )
}

export const BasicWidgetApp: React.FC<PropsWithChildren> = props => {
  const { children } = props
  return <Provider store={store}>{children}</Provider>
}
